import { reduxForm } from 'redux-form/immutable';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  selectAlpsFormInitialValues,
  getPendingSubmit,
  selectTermsFormInitialValues,
  handleTermsSubmit,
  getSubmitSource
} from '../../../../redux/modules/entities/alps/selectors';
import { termsFormValidation } from '../validation';
import TermsForm from './layout';
import { setTermsForm } from '../../../../redux/modules/entities/alps/actions';

const CreateTermsForm = compose(
  connect((state) => ({
    form: 'alps:termsForm',
  })),
  reduxForm({
    onSubmit: handleTermsSubmit,
    validate: termsFormValidation,
    destroyOnUnmount: true,
  })
)(TermsForm);

export const mapStateToProps = (state) => {
  return {
  newArtifact: getPendingSubmit(state),
  oldArtifact: selectAlpsFormInitialValues(state),
  initialValues: selectTermsFormInitialValues(state),
  submitSource: getSubmitSource(state),
  key: 'termsForm',
}};

export const actions = {
  setTermsForm,
};

export default connect(mapStateToProps, actions)(CreateTermsForm);
